<h2 mat-dialog-title>{{ data.title || "Confirm" }}</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>
  <p>
    <strong>{{ data.additionalMessage }}</strong>
  </p>
  @if(data.enableTextField){
  <mat-form-field>
    <mat-label>{{ data.textFieldLabel }}</mat-label>
    <!-- <textarea matInput [(ngModel)]="textFieldValue"></textarea> -->
    <textarea
      matInput
      [(ngModel)]="data.textFieldValue"
      [placeholder]="data.textFieldPlaceholder"
      [rows]="data.rows"
      [maxlength]="data.textFieldMaxLength"
    ></textarea>
    @if(data.mandatoryTextField){
    <mat-hint class="required-indicator"
      >*this field is mandatory, min {{ data.minlengthTextField }} characters,
      max {{ data.textFieldMaxLength }} characters</mat-hint
    >
    }
  </mat-form-field>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if(data.showCancel !== false && data.cancelText){
  <button mat-button (click)="onCancel()">
    {{ data.cancelText || "Cancel" }}
  </button>
  }
  <button
    mat-flat-button
    (click)="onConfirm()"
    [ngClass]="data.confirmButtonClass"
    [class.gray-out]="
      data.mandatoryTextField &&
      data.minlengthTextField &&
      data.textFieldValue &&
      data.textFieldValue.length < data.minlengthTextField
    "
    [disabled]="
      data.mandatoryTextField &&
      data.minlengthTextField &&
      data.textFieldValue &&
      data.textFieldValue.length < data.minlengthTextField
    "
  >
    {{ data.confirmText || "OK" }}
  </button>
</mat-dialog-actions>
